// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { RegistrarService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Registrar';
import { InstrumentConfigurationFactory } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Configuration/Instrument';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useCreateDtccTokenInstrumentConfiguration: () => UseMutationResult<
  void,
  string,
  {
    registrarServiceCid: ContractId<RegistrarService>;
    instrumentConfigurationFactoryCid: ContractId<InstrumentConfigurationFactory>;
    tokenName: string;
    tokenSymbol: string;
    cusip: string;
    shortDescription: string;
    issueType: string;
    issueSubtype: string;
    properties: { [key: string]: string };
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['createDtccTokenInstrumentConfiguration', ledgerApi],
    mutationFn: async ({
      registrarServiceCid,
      instrumentConfigurationFactoryCid,
      tokenName,
      tokenSymbol,
      cusip,
      shortDescription,
      issueType,
      issueSubtype,
      properties,
    }) => {
      return ledgerApi.createRegistryDtccTokenInstrumentConfiguration(
        registrarServiceCid,
        instrumentConfigurationFactoryCid,
        tokenName,
        tokenSymbol,
        cusip,
        shortDescription,
        issueType,
        issueSubtype,
        properties,
      );
    },
    retry: false,
  });
};

export default useCreateDtccTokenInstrumentConfiguration;
